"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImmersive3DModelEssenceProperty = exports.immersive3DModelEssencePropertyDefinition = void 0;
exports.immersive3DModelEssencePropertyDefinition = {
    view: { label: '3D Model' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: ['Immersive 3D Model'],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'immersive-3d-model-essence',
};
const isImmersive3DModelEssenceProperty = (prop) => {
    return prop.name === exports.immersive3DModelEssencePropertyDefinition.name;
};
exports.isImmersive3DModelEssenceProperty = isImmersive3DModelEssenceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1tZXJzaXZlLTNkLW1vZGVsLWVzc2VuY2UucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9pbW1lcnNpdmUtM2QtbW9kZWwtZXNzZW5jZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHlDQUF5QyxHQUFHO0lBQ3ZELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUU7SUFDM0IsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsQ0FBQyxvQkFBb0IsQ0FBQztTQUNqQztLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSw0QkFBNEI7Q0FDSCxDQUFBO0FBSTFCLE1BQU0saUNBQWlDLEdBQUcsQ0FBQyxJQUFrQixFQUEyQyxFQUFFO0lBQy9HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxpREFBeUMsQ0FBQyxJQUFJLENBQUE7QUFDckUsQ0FBQyxDQUFBO0FBRlksUUFBQSxpQ0FBaUMscUNBRTdDIn0=